import { memo } from "react";
import GainfulLoading from "Components/GainfulLoading";

const QuizLoading = (props) => (
  <>
    <GainfulLoading />
  </>
);

export default memo(QuizLoading);
